'use client';
import useTranslation from '@repo/ui/src/context/Translation/useTranslation';
import { YoutubeLinkProps } from '@repo/ui/src/types/youtubeLink';
import WatchNowButton from '@repo/ui/src/components/Button/WatchNowButton';
import { CopyWrapper, SectionContent } from './styles';
import { ModalID, useModal } from '@repo/ui/src/modules/UI';

export interface Props {
  lilHeading?: string;
  headingLine1?: string;
  headingLine2?: string;
  paragraph?: string;
  youtubeLink?: YoutubeLinkProps;
}

const Copy = ({ lilHeading, headingLine1, headingLine2, paragraph, youtubeLink }: Props) => {
  const { push } = useModal(ModalID.video);
  const { t } = useTranslation();
  return (
    <SectionContent>
      <CopyWrapper>
        {lilHeading && <span>{lilHeading}</span>}
        {headingLine1 && <h1>{headingLine1}</h1>}
        {headingLine2 && <h4>{headingLine2}</h4>}
        <hr className="border-2 w-10 border-brand-300 my-4" />
        {paragraph && <p>{paragraph}</p>}
        {youtubeLink && (
          <WatchNowButton
            setOpenModal={() =>
              push({ youtubeLink, playlistItems: youtubeLink?.associatedPlaylist?.body })
            }
            text={t('genericContent.videoPlayButtonText', undefined, {
              default: 'Watch Now',
            })}
          />
        )}
      </CopyWrapper>
    </SectionContent>
  );
};

export default Copy;
